import { useEffect } from "react";

/**
 * Custom hook to set the meta image of the document.
 * @param imageUrl - The URL of the image to set for the meta tag.
 */
export const useMetaImage = (imageUrl?: string) => {
  useEffect(() => {
    const metaImageTag = document.querySelector('meta[property="og:image"]');
    const prevImageUrl = metaImageTag?.getAttribute("content") || "";

    if (imageUrl) {
      if (metaImageTag) {
        metaImageTag.setAttribute("content", imageUrl);
      } else {
        const newMetaTag = document.createElement("meta");
        newMetaTag.setAttribute("property", "og:image");
        newMetaTag.setAttribute("content", imageUrl);
        document.head.appendChild(newMetaTag);
      }
    }

    return () => {
      if (metaImageTag) {
        metaImageTag.setAttribute("content", prevImageUrl);
      }
    };
  }, [imageUrl]);
};
